var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-text-tag"},[_c('div',{staticClass:"color-circle",style:({ backgroundColor: _vm.circleColor })}),_c('span',{staticClass:"tag-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }